<template>
  <ul
    v-if="!isEmpty(socials)"
    class="site-footer__socials"
  >
    <li
      v-for="(link, index) of socials"
      :key="index"
    >
      <a
        :href="link.url"
        target="_blank"
        rel="noopener noreferrer"
        :title="link.title"
        :aria-label="getAriaLabel(link)"
      >
        <icon-instagram
          v-if="matchedSocials(link.url, 'instagram')"
          :alt="'Instagram'"
        />
        <icon-facebook
          v-if="matchedSocials(link.url, 'facebook')"
          :alt="'Facebook'"
        />
        <icon-twitter
          v-if="matchedSocials(link.url, 'twitter')"
          :alt="'Twitter'"
        />
      </a>
    </li>
  </ul>
</template>

<script>

/**
 * Vue: Site footer socials
 * -----------------------------------------------------------------------------
 * Site footer social icons.
 *
 * @param {Object} socials - social media links
 */

import { isEmpty } from '~/helpers/general'

import IconFacebook from '~icons/social/facebook.svg'
import IconInstagram from '~icons/social/instagram.svg'
import IconTwitter from '~icons/social/twitter.svg'

export default {
  name: 'SiteFooterSocials',

  components: {
    IconFacebook,
    IconInstagram,
    IconTwitter,
  },

  props: {
    socials: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      email: '',
      phone: '',
      newsletterSuccess: false,
      newsletterFailed: false,
      errorMessage: '',
      smsConsent: false,
      validations: {
        email: false,
        phone: false,
      },
    }
  },

  methods: {

    /**
     * Checks for empty array
     * @returns {Boolean}
     */
    isEmpty,

    /**
     * Check if social platform's name matches a social icon.
     * @param {String} url - The social profile from the section settings.
     * @param {String} name - The domain name of the platform for this icon.
     * @returns {Boolean}
     */
    matchedSocials(url, name) {
      return url.toLowerCase().includes(name)
    },

    /**
     * Get aria-label for social link
     * @param {Object} link - The social link object.
     * @returns {String}
     */
    getAriaLabel(link) {
      const platforms = ['instagram', 'facebook', 'twitter']
      const found = platforms?.find(name => this.matchedSocials(link.url, name))
      const platform = found ? found?.charAt(0)?.toUpperCase() + found?.slice(1) : ''
      return platform ? `Visit our ${platform} page` : 'Visit our social page'
    },
  },
}
</script>
